module.exports = __webpack_public_path__ + "static/media/activecross.416f28be.svg";